import React, { Suspense } from "react";
import { Route, Switch, Redirect, useLocation, matchPath } from "react-router-dom";
import ActionTypes from "../common/constants/ActionTypes";
import Dashboard from "../pages/dashboard/Dashboard";
import EditDepartmentMaster from "../pages/masters/DepartmentMaster/EditDepatmentMaster";
import WMSLogin from "../pages/WmsLogin/WmsLogin";
import EditUomMaster from "../pages/masters/UomMaster/EditUomMaster.js";

const Purchaseorder = React.lazy(() => import("../pages/purchaseorder"));
const CreatePO = React.lazy(() =>
  import("../pages/purchaseorder/CreatePO/CreatePurchaseOrder")
);

const EditPO = React.lazy(() =>
  import("../pages/purchaseorder/CreatePO/EditPO")
);

// Job
const ListJob = React.lazy(() => import("../pages/job/JobLists/JobLists"));
const CreateJob = React.lazy(() => import("../pages/job/Createjob/CreateJob"));
const SapGrnBulkUpload = React.lazy(() => import("../pages/job/SapGrnBulkUpload/SapGrnBulkUpload"));
const DamageClaim = React.lazy(() =>
  import("../pages/job/DamageClaim/DamgeClaim")
);
const CreateJobDetailsForm = React.lazy(() =>
  import("../pages/job/CreateJobDetailsForm")
);
const EditJob = React.lazy(() => import("../pages/job/Createjob/EditJob"));
const ViewJob = React.lazy(() =>
  import("../pages/job/Createjob/ViewJob/ViewJob")
);
const JobVehicle = React.lazy(() => import("../pages/job/JobVehicle"));
const JobVehicleRelease = React.lazy(() => import("../pages/job/JobVehicleRelease"));
const JobPrimaryGrn = React.lazy(() => import("../pages/job/JobPrimaryGrn"));

const JobDiversionOrUnload = React.lazy(() =>
  import("../pages/job/jobdiversionorunload")
);
const JobVehicleDiversion = React.lazy(() =>
  import("../pages/job/JobDiversion/JobVehicleDiversion")
);
const EditJobDiversion = React.lazy(() =>
  import("../pages/job/JobDiversion/EditJobDiversion")
);
const CreatePrimaryGRN = React.lazy(() =>
  import("../pages/job/PrimartGRn/CreatePrimaryGRN")
);
const EditPrimaryGRN = React.lazy(() =>
  import("../pages/job/PrimartGRn/EditPrimaryGRN")
);
const CreateSecondaryGRN = React.lazy(() =>
  import("../pages/job/SecondaryGRN/CreateSecondaryGRN")
);
const EditSecondaryGRN = React.lazy(() =>
  import("../pages/job/SecondaryGRN/EditSecondaryGRN")
);

const CreateUnload = React.lazy(() =>
  import("../pages/job/UnloadingAdvice/CreateUnload")
);
const EditUnloadAdvice = React.lazy(() =>
  import("../pages/job/UnloadingAdvice/EditUnloadAdvice")
);

const ListSafetyObservation = React.lazy(() =>
  import("../pages/safety/safetyObservation/Index")
);

const ListDamageCliam = React.lazy(() => import("../pages/DamageCliam/index"));

const LisStockVerification = React.lazy(() =>
  import("../pages/stockVerification/index")
);
const AuditReport = React.lazy(() => import("../pages/auditReport/index"));
const EditDamageCliam = React.lazy(() =>
  import("../pages/DamageCliam/EditDamageCliam")
);

const EditSafetyToolsTackles = React.lazy(() =>
  import("../pages/safety/SafetyToolsAndTackels/EditSafetyToolsTackles")
);

const ListToolsTackles = React.lazy(() =>
  import("../pages/safety/SafetyToolsAndTackels/index")
);

// indent
const ListIndent = React.lazy(() => import("../pages/indent/index"));
const CreateIndent = React.lazy(() =>
  import("../pages/indent/Createindent/CreateIndent")
);
const EditIndent = React.lazy(() =>
  import("../pages/indent/Createindent/EditIndent")
);
const CreateLoadingAdvice = React.lazy(() =>
  import("../pages/indent/IndentLoadingAdvice/CreateLoadingAdvise")
);
const EditLoadingAdvice = React.lazy(() =>
  import("../pages/indent/IndentLoadingAdvice/EditLoadingAdvice")
);

const CreateIndentTransporter = React.lazy(() =>
  import("../pages/indent/IndentTransporter/CreateIndentTranporter")
);
const EditIndentTransporter = React.lazy(() =>
  import("../pages/indent/IndentTransporter/EditIndentTransporter")
);
const GoodsJob = React.lazy(() =>
  import("../pages/indent/IndentGoods/GoodsJob")
);
const Delivery = React.lazy(() =>
  import("../pages/indent/IndentDelivery/Delivery")
);
const EditDelivery = React.lazy(() =>
  import("../pages/indent/IndentDelivery/EditDelivery")
);
const EditGoodsJob = React.lazy(() =>
  import("../pages/indent/IndentGoods/EditGoodsJob")
);

//master screens
const ListUserMaster = React.lazy(() =>
  import("../pages/User Authorization/index")
);
const UserMaster = React.lazy(() =>
  import("../pages/User Authorization/UserMaster")
);
const EditUserMaster = React.lazy(() =>
  import("../pages/User Authorization/EditUser")
);

const ListCustomerMaster = React.lazy(() =>
  import("../pages/masters/CustomerMaster/index")
);
const CustomerMaster = React.lazy(() =>
  import("../pages/masters/CustomerMaster/CustomerMaster")
);
const EditCustomerMaster = React.lazy(() =>
  import("../pages/masters/CustomerMaster/EditCustomer")
);
const ListWarehouseMaster = React.lazy(() =>
  import("../pages/masters/WarehouseMaster/index")
);
const WarehouseMaster = React.lazy(() =>
  import("../pages/masters/WarehouseMaster/WarehouseMaster")
);
const EditWarehouseMaster = React.lazy(() =>
  import("../pages/masters/WarehouseMaster/EditWarehouseMaster")
);
const ListEquipmentMaster = React.lazy(() =>
  import("../pages/masters/EquipmentMaster/index")
);
const EquipmentMaster = React.lazy(() =>
  import("../pages/masters/EquipmentMaster/EquipmentMaster")
);
const EditEquipmentMaster = React.lazy(() =>
  import("../pages/masters/EquipmentMaster/EditEquipmentMaster")
);
const ListConsignmentMaster = React.lazy(() =>
  import("../pages/masters/ConsignmentMaster/index")
);

const ListMaterialGrouptMaster = React.lazy(() =>
  import("../pages/masters/MaterialGroupMaster/Index")
);
const ListCustomStationtMaster = React.lazy(() =>
  import("../pages/masters/CustomStationMaster/Index")
);

const ConsignmentMaster = React.lazy(() =>
  import("../pages/masters/ConsignmentMaster/ConsignmentTypeMaster")
);
const EditConsignmentMaster = React.lazy(() =>
  import("../pages/masters/ConsignmentMaster/EditConsignmentMaster")
);
const ListCurrencyMaster = React.lazy(() =>
  import("../pages/masters/CurrencyMaster/index")
);
const CurrencyMaster = React.lazy(() =>
  import("../pages/masters/CurrencyMaster/CurrencyMaster")
);
const EditCurrencyMaster = React.lazy(() =>
  import("../pages/masters/CurrencyMaster/EditCurrencyMaster")
);
const ListEmployeeMaster = React.lazy(() =>
  import("../pages/masters/EmployeeMaster/index")
);
const EmployeeMaster = React.lazy(() =>
  import("../pages/masters/EmployeeMaster/EmployeeMaster")
);
const EditEmployeeMaster = React.lazy(() =>
  import("../pages/masters/EmployeeMaster/EditEmployeeMaster")
);
const ListEmployerMaster = React.lazy(() =>
  import("../pages/masters/EmployerMaster/index")
);
const EmployerMaster = React.lazy(() =>
  import("../pages/masters/EmployerMaster/EmployerMaster")
);
const EditEmployerMaster = React.lazy(() =>
  import("../pages/masters/EmployerMaster/EditEmployerMaster")
);
const ListSupplierMaster = React.lazy(() =>
  import("../pages/masters/SupplierMaster/index")
);
const SupplierMaster = React.lazy(() =>
  import("../pages/masters/SupplierMaster/SupplierMaster")
);
const EditSupplierMaster = React.lazy(() =>
  import("../pages/masters/SupplierMaster/EditSupplierMaster")
);
const ListTransporterMaster = React.lazy(() =>
  import("../pages/masters/TransporterMaster/index")
);
const TransporterMaster = React.lazy(() =>
  import("../pages/masters/TransporterMaster/TransporterMaster")
);
const EditTransporterMaster = React.lazy(() =>
  import("../pages/masters/TransporterMaster/EditTransporterMaster")
);
const ListPVCategoryMaster = React.lazy(() =>
  import("../pages/masters/PVCategoryMaster/index")
);
const PVCategoryMaster = React.lazy(() =>
  import("../pages/masters/PVCategoryMaster/PVCategoryMaster")
);
const EditPVCategoryMaster = React.lazy(() =>
  import("../pages/masters/PVCategoryMaster/EditPVCategoryMaster")
);
const ListToolsMaster = React.lazy(() =>
  import("../pages/masters/ToolsMaster/index")
);
const ToolsMaster = React.lazy(() =>
  import("../pages/masters/ToolsMaster/ToolsMaster")
);
const EditToolsMaster = React.lazy(() =>
  import("../pages/masters/ToolsMaster/EditToolsMaster")
);
const ListSpareMaster = React.lazy(() =>
  import("../pages/masters/SpareMaster/index")
);
const SpareMaster = React.lazy(() =>
  import("../pages/masters/SpareMaster/SpareMaster")
);
const EditSpareMaster = React.lazy(() =>
  import("../pages/masters/SpareMaster/EditSpareMaster")
);
const ListSACCodeMaster = React.lazy(() =>
  import("../pages/masters/SACCodeMaster/index")
);

const ListParametereMaster = React.lazy(() =>
  import("../pages/masters/ParameterMaster/Index")
);

const SACCodeMaster = React.lazy(() =>
  import("../pages/masters/SACCodeMaster/SACCodeMaster")
);
const EditSACCodeMaster = React.lazy(() =>
  import("../pages/masters/SACCodeMaster/EditSacCodeMaster")
);
const ListPOMaster = React.lazy(() =>
  import("../pages/masters/POMaster/index")
);
const POMaster = React.lazy(() => import("../pages/masters/POMaster/POMaster"));
const EditPOMaster = React.lazy(() =>
  import("../pages/masters/POMaster/EditPOMaster")
);
const ListWOMaster = React.lazy(() =>
  import("../pages/masters/W.O Master/index")
);
const WOMaster = React.lazy(() =>
  import("../pages/masters/W.O Master/WoMaster")
);
const EditWOMaster = React.lazy(() =>
  import("../pages/masters/W.O Master/EditWoMaster")
);
const ListBinMaster = React.lazy(() => import("../pages/masters/BinMaster"));
const BinMaster = React.lazy(() =>
  import("../pages/masters/BinMaster/BinMaster")
);
const EditBinMaster = React.lazy(() =>
  import("../pages/masters/BinMaster/EditBinMaster")
);
const ListCommodityMaster = React.lazy(() =>
  import("../pages/masters/CommodityMaster")
);
const CommodityMaster = React.lazy(() =>
  import("../pages/masters/CommodityMaster/CommodityMaster")
);
const EditCommodityMaster = React.lazy(() =>
  import("../pages/masters/CommodityMaster/EditCommodityMaster")
);
const ListTransporterRepresentativeMaster = React.lazy(() =>
  import("../pages/masters/TransporterRepresentativeMaster")
);
const TransporterRepresentativeMaster = React.lazy(() =>
  import(
    "../pages/masters/TransporterRepresentativeMaster/TransporterRepresentativeMaster"
  )
);
const EditTransporterRepresentativeMaster = React.lazy(() =>
  import(
    "../pages/masters/TransporterRepresentativeMaster/EditTransporterRepresentativeMaster"
  )
);
const ListContactMaster = React.lazy(() =>
  import("../pages/masters/ContactMaster")
);
const ContactMaster = React.lazy(() =>
  import("../pages/masters/ContactMaster/ContactMaster")
);

const DepartmentMaster = React.lazy(() =>
  import("../pages/masters/DepartmentMaster/DepartmentMaster")
);

const EditCDepartmenttMaster = React.lazy(() =>
  import("../pages/masters/DepartmentMaster/EditDepatmentMaster")
);
const ChaMaster = React.lazy(() =>
  import("../pages/masters/ChaMaster/ChaMaster")
);

const EditChaMaster = React.lazy(() =>
  import("../pages/masters/ChaMaster/EditChaMaster")
);

const EditContactMaster = React.lazy(() =>
  import("../pages/masters/ContactMaster/EditContactMaster")
);
const ListVendorServiceMaster = React.lazy(() =>
  import("../pages/masters/VendorServiceMaster")
);
const VendorServiceMaster = React.lazy(() =>
  import("../pages/masters/VendorServiceMaster/VendorServiceMaster")
);
const EditVendorServiceMaster = React.lazy(() =>
  import("../pages/masters/VendorServiceMaster/EditVendorServiceMaster")
);
const ListEquipmentChecklistMaster = React.lazy(() =>
  import("../pages/masters/EquipmentChecklistMaster")
);
const EquipmentChecklistMaster = React.lazy(() =>
  import("../pages/masters/EquipmentChecklistMaster/EquipmentChecklistMaster")
);
const EditEquipmentChecklistMaster = React.lazy(() =>
  import(
    "../pages/masters/EquipmentChecklistMaster/EditEquipmentChecklistMaster"
  )
);
const ListUomMaster = React.lazy(() =>
  import("../pages/masters/UomMaster/index.js")
);
const UomMaster = React.lazy(() => import("../pages/masters/UomMaster/UomMaster.js"))

// Safety Components
const CreateSafetyObservation = React.lazy(() =>
  import("../pages/safety/safetyObservation/CreateSafetyObservation")
);
const EditSafetyObservation = React.lazy(() =>
  import("../pages/safety/safetyObservation/EditSafetyObservation")
);
const CreateToolsAndTackels = React.lazy(() =>
  import("../pages/safety/SafetyToolsAndTackels/CreateToolsAndTackels.js")
);

const CreateSafetyEmployee = React.lazy(() =>
  import("../pages/safety/safetyEmployee/CreateSafetyEmployee")
);

const CreateEquipmentComplaince = React.lazy(() =>
  import("../pages/safety/EquipmentTypes/CreateEquipmentComplaince")
);

const CreateSpareStockManagement = React.lazy(() =>
  import("../pages/safety/SpareStockManagement/SpareStockManagement")
);

// View Primary GRN
const ViewPrimaryGRN = React.lazy(() =>
  import("../pages/job/PrimartGRn/ViewPrimaryGRN/VewPrimaryGRN")
);

// View Unload Advice
const ViewUnloadAdvice = React.lazy(() =>
  import("../pages/job/UnloadingAdvice/ViewUnloadAdvice/ViewUnloadAdvice")
);

// View Job Diversion
const ViewJobDiversion = React.lazy(() =>
  import("../pages/job/JobDiversion/ViewJobDiversion/ViewVehicleDiversion")
);

// View Indent
const ViewIndent = React.lazy(() =>
  import("../pages/indent/Createindent/ViewIndent/ViewIndent")
);

// View Indent Delivery
const ViewIndentDelivery = React.lazy(() =>
  import("../pages/indent/IndentDelivery/ViewIndentDelivery")
);

// View Indent Goods Issue
const ViewIndentGoodsIssue = React.lazy(() =>
  import("../pages/indent/IndentGoods/ViewIndentGoodsIssue")
);

// View Indent Loading Advice
const ViewIndentLoadingAdvice = React.lazy(() =>
  import(
    "../pages/indent/IndentLoadingAdvice/ViewLoadingAdvice/ViewLoadingAdvice"
  )
);

// View Indent Transporter Details
const ViewIndentTransporterDetails = React.lazy(() =>
  import(
    "../pages/indent/IndentTransporter/ViewIndentTransporter/ViewIndentTransporter"
  )
);

// Indent Vehicle Reporting
const IndentVehicleReporting = React.lazy(() =>
  import(
    "../pages/indent/IndentLoadingAdvice/VehicleReporting/VehicleReporting"
  )
);

const IndentVehicleLoading = React.lazy(() =>
  import("../pages/indent/IndentVehicleLoading")
);

const IndentVehicleGoods = React.lazy(() =>
  import("../pages/indent/IndentVehicleGoods")
);

const IndentVehicleDelivery = React.lazy(() =>
  import("../pages/indent/IndentVehicleDelivery")
);

const IndentVehicleTracking = React.lazy(() =>
  import("../pages/indent/IndentVehicleTracking")
);

const CreateVehicleTracking = React.lazy(() =>
  import("../pages/indent/vehicleTracking/VehicleTracking")
);

const EditVehicleTracking = React.lazy(() =>
  import("../pages/indent/vehicleTracking/EditVehicleTracking")
);

const IndentEditVehicleReport = React.lazy(() =>
  import(
    "../pages/indent/IndentLoadingAdvice/VehicleReporting/EditVehicleReporting"
  )
);

const CreateStockVerification = React.lazy(() =>
  import("../pages/stockVerification/StockVerification")
);

const NoDataFound = React.lazy(() => import("../pages/NoDataFound"));

// View Indent Vehicle Tracking
const ViewIndentVehicleTracking = React.lazy(() =>
  import("../pages/indent/vehicleTracking/ViewVehicleTracking")
);

// Indent Vehicle Reporting View
const ViewIndentVehicleReporting = React.lazy(() =>
  import(
    "../pages/indent/IndentLoadingAdvice/VehicleReporting/viewVehicleReporting/ViewVehicleReporting"
  )
);

const ListDepartmentMaster = React.lazy(() =>
  import("../pages/masters/DepartmentMaster/index")
);
const ListChaMaster = React.lazy(() =>
  import("../pages/masters/ChaMaster/index")
);

const ListConsigneeMaster = React.lazy(() =>
  import("../pages/masters/ConsigneeMaster/index")
);

const ListConsignerMaster = React.lazy(() =>
  import("../pages/masters/ConsignerMaster/index")
);

// Edit Stock Verification
const EditStockVerification = React.lazy(() =>
  import("../pages/stockVerification/EditStockVerification")
);

const EditEquipmenrFuelConsumption = React.lazy(() =>
  import(
    "../pages/safety/EquipmentTypes/Equipment-Fuel Consumption/EditEquipmentFuelConsumption"
  )
);

const EditEquipmenrPreventiveMaintainance = React.lazy(() =>
  import(
    "../pages/safety/EquipmentTypes/Equip-Preventive Maintenance/EditEquipmentPreventiveMaintainance"
  )
);

const EditEquipmentMaintainance = React.lazy(() =>
  import(
    "../pages/safety/EquipmentTypes/EquipmentMaintenance/EditEquipmentMaintaince"
  )
);

const EditEquipmentComplianance = React.lazy(() =>
  import(
    "../pages/safety/EquipmentTypes/EquipmentComplaince/EditEquipmentCompliance"
  )
);

const EquipmentComplianceList = React.lazy(() =>
  import("../pages/safety/EquipmentTypes/Index.js")
);

const InvoiceList = React.lazy(() => import("../pages/Invoice/Index"));

const SpareStockManagementList = React.lazy(() =>
  import("../pages/safety/SpareStockManagement/Index")
);

const CreateInvoice = React.lazy(() =>
  import("../pages/Invoice/CreateInvoice")
);

const EditInvoice = React.lazy(() => import("../pages/Invoice/EditInvoice"));

const UpdateSafetyEmployee = React.lazy(() =>
  import("../pages/safety/safetyEmployee/UpdateSafetyEmployee")
);

// Edit Spare Stock Management
const EditSpareStockManagement = React.lazy(() =>
  import("../pages/safety/SpareStockManagement/EditSpareStockManagement")
);

const SafetyEmployeeList = React.lazy(() =>
  import("../pages/safety/safetyEmployee/Index")
);
// Reports

const StockReport = React.lazy(() =>
  import("../pages/Reports/Stock Report/index")
);
const StockReportIMS = React.lazy(() =>
  import("../pages/Reports/IMS Stock Report/index")
);
const StockReportRM = React.lazy(() =>
  import("../pages/Reports/RM MM Stock Report/index")
);
const StockReportEXWH = React.lazy(() =>
  import("../pages/Reports/EXWH Stock Report/index")
);
const AgricoReport = React.lazy(() =>
  import("../pages/Reports/Agrico Report/index")
);

const GRNReport = React.lazy(() => import("../pages/Reports/GRN Report/index"));

const PackageLevelReport = React.lazy(() =>
  import("../pages/Reports/Package Level Report/index.js")
);
const VIVOReceiptReport = React.lazy(() =>
  import("../pages/Reports/VIVO Receipt Report/index")
);
const VIVOISSUEReport = React.lazy(() =>
  import("../pages/Reports/VIVO ISSUE Report/index")
);
const VIVOReport = React.lazy(() =>
  import("../pages/Reports/VIVO Report/index")
);
const GIReport = React.lazy(() => import("../pages/Reports/GI Report/index"));

const MaterialPickListReport = React.lazy(() =>
  import("../pages/Reports/Materail PickList Report/index")
);

const CreateCustomDetails = React.lazy(() =>
  import("../pages/job/SecondaryGRN/CreateCustomDetails")
);

const ViewCustomDetails = React.lazy(() =>
  import("../pages/job/SecondaryGRN/ViewCustomDetails")
);

const UpdateCustomDetails = React.lazy(() =>
  import("../pages/job/SecondaryGRN/UpdateCustomDetails")
);

// form a and b
const FormA = React.lazy(() => import("../pages/Reports/FormA/index"));
const FormB = React.lazy(() => import("../pages/Reports/FormB/index"));

const UploadExcel = React.lazy(() =>
  import("../pages/masters/UploadExcelFromCHIAl/uploadExcel")
);

const SpaceCertificatesComponent = React.lazy(() =>
  import("../pages/masters/SpaceCertificates")
);

const BulkUploadData = React.lazy(() =>
  import("../pages/DataBulkUpload/databulkupload")
);

// const BulkUploadDataExwh = React.lazy(() =>
//   import("../pages/DataBulkUploadExwh/databulkupload")
// );

const DiversionReport = React.lazy(() =>
  import("../pages/Reports/DiversionReport/index")
);
const SapPendingReport = React.lazy(() =>
  import("../pages/Reports/SapGrnPendingReport/index")
);
const SapPendingReasonsList = React.lazy(() => import('../pages/masters/SapPendingReasons'))
const ReceiptTypeMaster = React.lazy(() => import('../pages/masters/ReceiptTypeMaster'));
const StockRegularization = React.lazy(() => import('../pages/StockRegularization/IndentStockRegBulkUpload'));
const VehicleTypeMasterList = React.lazy(() => import('../pages/masters/VehicleTypeMaster'))
const ListPackageMaster = React.lazy(() =>
  import("../pages/masters/PackageMaster/index.js")
);
const PackageMaster = React.lazy(() =>
  import("../pages/masters/PackageMaster/PackageMaster.js")
);
const EditPackageMaster = React.lazy(() =>
  import("../pages/masters/PackageMaster/EditPackageMaster.js")
);

// const routes = [
//   { path: `/${ActionTypes.LOB}`, exact: true },
//   { path: `/${ActionTypes.LOB}/dashboard`, exact: true },
//   { path: `/${ActionTypes.LOB}/listpurchaseorder`, exact: true },
//   { path: `/${ActionTypes.LOB}/listjob`, exact: true },
//   { path: `/${ActionTypes.LOB}/jobvehicle`, exact: true },
//   { path: `/${ActionTypes.LOB}/jobprimarygrn`, exact: true },
//   { path: `/${ActionTypes.LOB}/jobdiversionorunload`, exact: true },
//   { path: `/${ActionTypes.LOB}/listindent`, exact: true },
//   { path: `/${ActionTypes.LOB}/listauthorization`, exact: true },
//   { path: `/${ActionTypes.LOB}/dashboard`, exact: true },
//   { path: `/${ActionTypes.LOB}/dashboard`, exact: true },
//   { path: `/${ActionTypes.LOB}/masters/listcustomermaster`, exact: true },
//   { path: `/${ActionTypes.LOB}/masters/listwarehousemaster`, exact: true },
//   { path: `/${ActionTypes.LOB}/masters/listequipmentmaster`, exact: true },
//   { path: `/${ActionTypes.LOB}/masters/listconsignmentmaster`, exact: true },
//   { path: `/${ActionTypes.LOB}/masters/listmaterialgroupmaster`, exact: true },
//   { path: `/${ActionTypes.LOB}/masters/listcustomstationmaster`, exact: true },
//   { path: `/${ActionTypes.LOB}/masters/listcurrencymaster`, exact: true },
//   { path: `/${ActionTypes.LOB}/masters/listpackagemaster`, exact: true },
//   { path: `/${ActionTypes.LOB}/masters/listemployeemaster`, exact: true },
//   { path: `/${ActionTypes.LOB}/masters/listemployermaster`, exact: true },
//   { path: `/${ActionTypes.LOB}/masters/listsuppliermaster`, exact: true },
//   { path: `/${ActionTypes.LOB}/masters/listtransportermaster`, exact: true },
//   { path: `/${ActionTypes.LOB}/masters/listpvcategorymaster`, exact: true },
//   { path: `/${ActionTypes.LOB}/masters/listtoolsmaster`, exact: true },
//   { path: `/${ActionTypes.LOB}/masters/listsparemaster`, exact: true },
//   { path: `/${ActionTypes.LOB}/masters/listsaccodemaster`, exact: true },
//   { path: `/${ActionTypes.LOB}/masters/listparametermaster`, exact: true },
//   { path: `/${ActionTypes.LOB}/masters/listpomaster`, exact: true },
//   { path: `/${ActionTypes.LOB}/masters/listwomaster`, exact: true },
//   { path: `/${ActionTypes.LOB}/masters/listbinmaster`, exact: true },
//   { path: `/${ActionTypes.LOB}/masters/binmaster`, exact: true },
//   { path: `/${ActionTypes.LOB}/masters/listcommoditymaster`, exact: true },
//   { path: `/${ActionTypes.LOB}/masters/listtransporterrepresentativemaster`, exact: true },
//   { path: `/${ActionTypes.LOB}/masters/transporterrepresentativemaster`, exact: true },
//   { path: `/${ActionTypes.LOB}/masters/listcontactmaster`, exact: true },
//   { path: `/${ActionTypes.LOB}/masters/listvendorservicemaster`, exact: true },
//   { path: `/${ActionTypes.LOB}/masters/listequipmentchecklistmaster`, exact: true },
//   // Add other routes here
// ];

export default function PageRoutes(props) {

  // const location = useLocation();
  // const isValidRoute = routes.some(route =>
  //   matchPath(location.pathname, route)
  // );

  // if (!isValidRoute) {
  //   // Redirect to NotFound component or handle invalid route here
  //   return <Route exact render={() => <Redirect to={{
  //     pathname: sessionStorage.getItem("user_type") === 'Customer' ?
  //       `/${ActionTypes.LOB}/listindent` : `/${ActionTypes.LOB}/listindent`
  //   }} />} />
  // }

  return (
    <Switch>
      <Suspense fallback={<div></div>}>

        <Route exact path={`/${ActionTypes.LOB}`} component={WMSLogin} />
        <Route exact path={`/${ActionTypes.LOB}/dashboard`} component={Dashboard} />

        {/* Purchase Order */}

        {sessionStorage.getItem("user_type") === 'WH User' &&

          <>
            <Route exact
              path={`/${ActionTypes.LOB}/listpurchaseorder`}
              component={Purchaseorder}
            />
            <Route exact path={`/${ActionTypes.LOB}/createpo`} component={CreatePO} />
            <Route exact path={`/${ActionTypes.LOB}/editpo`} component={EditPO} />

            {/*  Job */}
            <Route exact path={`/${ActionTypes.LOB}/listjob`} component={ListJob} />

            <Route exact path={`/${ActionTypes.LOB}/createjob`} component={CreateJob} />
            <Route exact
              path={`/${ActionTypes.LOB}/jobdetails`}
              component={CreateJobDetailsForm}
            />
            <Route exact path={`/${ActionTypes.LOB}/editjob`} component={EditJob} />
            <Route exact path={`/${ActionTypes.LOB}/sapgrnbulkupload`} component={SapGrnBulkUpload} />

            <Route exact path={`/${ActionTypes.LOB}/jobvehicle`} component={JobVehicle} />
            <Route exact path={`/${ActionTypes.LOB}/jobvehiclerelease`} component={JobVehicleRelease} />
            <Route exact path={`/${ActionTypes.LOB}/jobprimarygrn`} component={JobPrimaryGrn} />

            <Route exact
              path={`/${ActionTypes.LOB}/jobdiversionorunload`}
              component={JobDiversionOrUnload}
            />

            <Route exact
              path={`/${ActionTypes.LOB}/jobvehiclediversion`}
              component={JobVehicleDiversion}
            />
            <Route exact
              path={`/${ActionTypes.LOB}/editjobdiversion`}
              component={EditJobDiversion}
            />
            <Route exact
              path={`/${ActionTypes.LOB}/createprimarygrn`}
              component={CreatePrimaryGRN}
            />
            <Route exact
              path={`/${ActionTypes.LOB}/editprimarygrn`}
              component={EditPrimaryGRN}
            />
            <Route exact
              path={`/${ActionTypes.LOB}/createsecondarygrn`}
              component={CreateSecondaryGRN}
            />
            <Route exact
              path={`/${ActionTypes.LOB}/editsecondarygrn`}
              component={EditSecondaryGRN}
            />
            <Route exact
              path={`/${ActionTypes.LOB}/jobunloadingadvice`}
              component={CreateUnload}
            />
            <Route exact
              path={`/${ActionTypes.LOB}/editunload`}
              component={EditUnloadAdvice}
            />
            {/* indent routes */}
            <Route exact path={`/${ActionTypes.LOB}/listindent`} component={ListIndent} />
            <Route exact
              path={`/${ActionTypes.LOB}/createindent`}
              component={CreateIndent}
            />
            <Route exact path={`/${ActionTypes.LOB}/editindent`} component={EditIndent} />
            <Route exact
              path={`/${ActionTypes.LOB}/createloadingadvice`}
              component={CreateLoadingAdvice}
            />
            <Route exact
              path={`/${ActionTypes.LOB}/editloadingadvice`}
              component={EditLoadingAdvice}
            />
            <Route exact
              path={`/${ActionTypes.LOB}/createindenttransporter`}
              component={CreateIndentTransporter}
            />
            <Route exact
              path={`/${ActionTypes.LOB}/editindenttansporter`}
              component={EditIndentTransporter}
            />
            <Route exact path={`/${ActionTypes.LOB}/goodsjob`} component={GoodsJob} />
            <Route exact
              path={`/${ActionTypes.LOB}/editGoodsJob`}
              component={EditGoodsJob}
            />
            <Route exact path={`/${ActionTypes.LOB}/delivery`} component={Delivery} />
            <Route exact
              path={`/${ActionTypes.LOB}/editdelivery`}
              component={EditDelivery}
            />

            <Route exact
              path={`/${ActionTypes.LOB}/damageclaim`}
              component={DamageClaim}
            />
            {/*master screens */}
            <Route exact
              path={`/${ActionTypes.LOB}/listauthorization`}
              component={ListUserMaster}
            />
            <Route exact
              path={`/${ActionTypes.LOB}/createauthorizationuser`}
              component={UserMaster}
            />
            <Route exact
              path={`/${ActionTypes.LOB}/editauthorizationuser`}
              component={EditUserMaster}
            />

            <Route exact
              path={`/${ActionTypes.LOB}/masters/listcustomermaster`}
              component={ListCustomerMaster}
            />
            <Route exact
              path={`/${ActionTypes.LOB}/masters/customermaster`}
              component={CustomerMaster}
            />
            <Route exact
              path={`/${ActionTypes.LOB}/masters/editcustomermaster`}
              component={EditCustomerMaster}
            />
            <Route exact
              path={`/${ActionTypes.LOB}/masters/listwarehousemaster`}
              component={ListWarehouseMaster}
            />
            <Route exact
              path={`/${ActionTypes.LOB}/masters/warehousemaster`}
              component={WarehouseMaster}
            />
            <Route exact
              path={`/${ActionTypes.LOB}/masters/editwarehousemaster`}
              component={EditWarehouseMaster}
            />
            <Route exact
              path={`/${ActionTypes.LOB}/masters/listequipmentmaster`}
              component={ListEquipmentMaster}
            />
            <Route exact
              path={`/${ActionTypes.LOB}/masters/equipmentmaster`}
              component={EquipmentMaster}
            />
            <Route exact
              path={`/${ActionTypes.LOB}/masters/editequipmentmaster`}
              component={EditEquipmentMaster}
            />
            <Route exact
              path={`/${ActionTypes.LOB}/masters/listconsignmentmaster`}
              component={ListConsignmentMaster}
            />

            <Route exact
              path={`/${ActionTypes.LOB}/masters/listmaterialgroupmaster`}
              component={ListMaterialGrouptMaster}
            />

            <Route exact
              path={`/${ActionTypes.LOB}/masters/listcustomstationmaster`}
              component={ListCustomStationtMaster}
            />

            <Route exact
              path={`/${ActionTypes.LOB}/masters/consignmentmaster`}
              component={ConsignmentMaster}
            />
            <Route exact
              path={`/${ActionTypes.LOB}/masters/editconsignmentmaster`}
              component={EditConsignmentMaster}
            />
            <Route exact
              path={`/${ActionTypes.LOB}/masters/listcurrencymaster`}
              component={ListCurrencyMaster}
            />
            <Route exact
              path={`/${ActionTypes.LOB}/masters/currencymaster`}
              component={CurrencyMaster}
            />
            <Route exact
              path={`/${ActionTypes.LOB}/masters/editcurrencymaster`}
              component={EditCurrencyMaster}
            />
            <Route exact
              path={`/${ActionTypes.LOB}/masters/listpackagemaster`}
              component={ListPackageMaster}
            />
            <Route exact
              path={`/${ActionTypes.LOB}/masters/packagemaster`}
              component={PackageMaster}
            />
            <Route exact
              path={`/${ActionTypes.LOB}/masters/editpackagemaster`}
              component={EditPackageMaster}
            />
            <Route exact
              path={`/${ActionTypes.LOB}/masters/listemployeemaster`}
              component={ListEmployeeMaster}
            />
            <Route exact
              path={`/${ActionTypes.LOB}/masters/employeemaster`}
              component={EmployeeMaster}
            />
            <Route exact
              path={`/${ActionTypes.LOB}/masters/editemployeemaster`}
              component={EditEmployeeMaster}
            />
            <Route exact
              path={`/${ActionTypes.LOB}/masters/listemployermaster`}
              component={ListEmployerMaster}
            />
            <Route exact
              path={`/${ActionTypes.LOB}/masters/employermaster`}
              component={EmployerMaster}
            />
            <Route exact
              path={`/${ActionTypes.LOB}/masters/editemployermaster`}
              component={EditEmployerMaster}
            />
            <Route exact
              path={`/${ActionTypes.LOB}/masters/listsuppliermaster`}
              component={ListSupplierMaster}
            />
            <Route exact
              path={`/${ActionTypes.LOB}/masters/suppliermaster`}
              component={SupplierMaster}
            />
            <Route exact
              path={`/${ActionTypes.LOB}/masters/editsuppliermaster`}
              component={EditSupplierMaster}
            />
            <Route exact
              path={`/${ActionTypes.LOB}/masters/listtransportermaster`}
              component={ListTransporterMaster}
            />
            <Route exact
              path={`/${ActionTypes.LOB}/masters/transportermaster`}
              component={TransporterMaster}
            />
            <Route exact
              path={`/${ActionTypes.LOB}/masters/edittransportermaster`}
              component={EditTransporterMaster}
            />
            <Route exact
              path={`/${ActionTypes.LOB}/masters/listpvcategorymaster`}
              component={ListPVCategoryMaster}
            />
            <Route exact
              path={`/${ActionTypes.LOB}/masters/pvcategorymaster`}
              component={PVCategoryMaster}
            />
            <Route exact
              path={`/${ActionTypes.LOB}/masters/editpvcategorymaster`}
              component={EditPVCategoryMaster}
            />
            <Route exact
              path={`/${ActionTypes.LOB}/masters/listtoolsmaster`}
              component={ListToolsMaster}
            />
            <Route exact
              path={`/${ActionTypes.LOB}/masters/toolsmaster`}
              component={ToolsMaster}
            />
            <Route exact
              path={`/${ActionTypes.LOB}/masters/edittoolsmaster`}
              component={EditToolsMaster}
            />
            <Route exact
              path={`/${ActionTypes.LOB}/masters/listsparemaster`}
              component={ListSpareMaster}
            />
            <Route exact
              path={`/${ActionTypes.LOB}/masters/sparemaster`}
              component={SpareMaster}
            />
            <Route exact
              path={`/${ActionTypes.LOB}/masters/editsparemaster`}
              component={EditSpareMaster}
            />
            <Route exact
              path={`/${ActionTypes.LOB}/masters/listsaccodemaster`}
              component={ListSACCodeMaster}
            />

            <Route exact
              path={`/${ActionTypes.LOB}/masters/listparametermaster`}
              component={ListParametereMaster}
            />

            <Route exact
              path={`/${ActionTypes.LOB}/masters/saccodemaster`}
              component={SACCodeMaster}
            />
            <Route exact
              path={`/${ActionTypes.LOB}/masters/editsaccodemaster`}
              component={EditSACCodeMaster}
            />
            <Route exact
              path={`/${ActionTypes.LOB}/masters/listpomaster`}
              component={ListPOMaster}
            />
            <Route exact
              path={`/${ActionTypes.LOB}/masters/pomaster`}
              component={POMaster}
            />

            <Route exact
              path={`/${ActionTypes.LOB}/masters/departmentmaster`}
              component={DepartmentMaster}
            />

            <Route exact
              path={`/${ActionTypes.LOB}/masters/editdepartmentmaster`}
              component={EditDepartmentMaster}
            />
            <Route exact
              path={`/${ActionTypes.LOB}/masters/chamaster`}
              component={ChaMaster}
            />

            <Route exact
              path={`/${ActionTypes.LOB}/masters/editchamaster`}
              component={EditChaMaster}
            />
            <Route exact
              path={`/${ActionTypes.LOB}/masters/editpomaster`}
              component={EditPOMaster}
            />
            <Route exact
              path={`/${ActionTypes.LOB}/masters/listwomaster`}
              component={ListWOMaster}
            />
            <Route exact
              path={`/${ActionTypes.LOB}/masters/womaster`}
              component={WOMaster}
            />
            <Route exact
              path={`/${ActionTypes.LOB}/masters/editwomaster`}
              component={EditWOMaster}
            />
            <Route exact
              path={`/${ActionTypes.LOB}/masters/listbinmaster`}
              component={ListBinMaster}
            />
            <Route exact
              path={`/${ActionTypes.LOB}/masters/binmaster`}
              component={BinMaster}
            />
            <Route exact
              path={`/${ActionTypes.LOB}/masters/editbinmaster`}
              component={EditBinMaster}
            />
            <Route exact
              path={`/${ActionTypes.LOB}/masters/listcommoditymaster`}
              component={ListCommodityMaster}
            />
            <Route exact
              path={`/${ActionTypes.LOB}/masters/commoditymaster`}
              component={CommodityMaster}
            />
            <Route exact
              path={`/${ActionTypes.LOB}/masters/editcommoditymaster`}
              component={EditCommodityMaster}
            />
            <Route exact
              path={`/${ActionTypes.LOB}/masters/listtransporterrepresentativemaster`}
              component={ListTransporterRepresentativeMaster}
            />
            <Route exact
              path={`/${ActionTypes.LOB}/masters/transporterrepresentativemaster`}
              component={TransporterRepresentativeMaster}
            />
            <Route exact
              path={`/${ActionTypes.LOB}/masters/edittransporterrepresentativemaster`}
              component={EditTransporterRepresentativeMaster}
            />
            <Route exact
              path={`/${ActionTypes.LOB}/masters/listcontactmaster`}
              component={ListContactMaster}
            />
            <Route exact
              path={`/${ActionTypes.LOB}/masters/contactmaster`}
              component={ContactMaster}
            />
            <Route exact
              path={`/${ActionTypes.LOB}/masters/editcontactmaster`}
              component={EditContactMaster}
            />
            <Route exact
              path={`/${ActionTypes.LOB}/masters/listvendorservicemaster`}
              component={ListVendorServiceMaster}
            />
            <Route exact
              path={`/${ActionTypes.LOB}/masters/vendorservicemaster`}
              component={VendorServiceMaster}
            />
            <Route exact
              path={`/${ActionTypes.LOB}/masters/editvendorservicemaster`}
              component={EditVendorServiceMaster}
            />
            <Route exact
              path={`/${ActionTypes.LOB}/masters/listequipmentchecklistmaster`}
              component={ListEquipmentChecklistMaster}
            />
            <Route exact
              path={`/${ActionTypes.LOB}/masters/equipmentchecklistmaster`}
              component={EquipmentChecklistMaster}
            />
            <Route exact
              path={`/${ActionTypes.LOB}/masters/editequipmentchecklistmaster`}
              component={EditEquipmentChecklistMaster}
            />

            {/* Safety Routes */}
            <Route exact
              path={`/${ActionTypes.LOB}/createsafetyobservation`}
              component={CreateSafetyObservation}
            />
            <Route exact
              path={`/${ActionTypes.LOB}/editsafetyobservation`}
              component={EditSafetyObservation}
            />

            <Route exact
              path={`/${ActionTypes.LOB}/safety/createsafetytoolsandtackles`}
              component={CreateToolsAndTackels}
            />

            <Route exact
              path={`/${ActionTypes.LOB}/create-safety-employee`}
              component={CreateSafetyEmployee}
            />

            <Route exact
              path={`/${ActionTypes.LOB}/equipmentcomplaince`}
              component={CreateEquipmentComplaince}
            />

            <Route exact
              path={`/${ActionTypes.LOB}/sparestockmanagement`}
              component={CreateSpareStockManagement}
            />

            <Route exact path={`/${ActionTypes.LOB}/job/viewjob`} component={ViewJob} />
            <Route exact
              path={`/${ActionTypes.LOB}/nodatafound`}
              component={NoDataFound}
            />

            <Route exact
              path={`/${ActionTypes.LOB}/safetyobservationlist`}
              component={ListSafetyObservation}
            />

            <Route exact
              path={`/${ActionTypes.LOB}/safety/toolstackleslist`}
              component={ListToolsTackles}
            />

            <Route exact
              path={`/${ActionTypes.LOB}/damagecliamlist`}
              component={ListDamageCliam}
            />

            <Route exact
              path={`/${ActionTypes.LOB}/stockverificationlist`}
              component={LisStockVerification}
            />

            <Route exact
              path={`/${ActionTypes.LOB}/auditreport`}
              component={AuditReport}
            />

            <Route exact
              path={`/${ActionTypes.LOB}/editdamagecliam`}
              component={EditDamageCliam}
            />

            <Route exact
              path={`/${ActionTypes.LOB}/safety/edittoolstackles`}
              component={EditSafetyToolsTackles}
            />

            <Route exact
              path={`/${ActionTypes.LOB}/viewprimarygrn`}
              component={ViewPrimaryGRN}
            />

            <Route exact
              path={`/${ActionTypes.LOB}/viewunload`}
              component={ViewUnloadAdvice}
            />

            <Route exact
              path={`/${ActionTypes.LOB}/viewjobdiversion`}
              component={ViewJobDiversion}
            />
            <Route exact path={`/${ActionTypes.LOB}/viewindent`} component={ViewIndent} />
            <Route exact
              path={`/${ActionTypes.LOB}/viewindentdelivery`}
              component={ViewIndentDelivery}
            />

            <Route exact
              path={`/${ActionTypes.LOB}/viewindentgoodsissue`}
              component={ViewIndentGoodsIssue}
            />

            <Route exact
              path={`/${ActionTypes.LOB}/viewindentloadingadvice`}
              component={ViewIndentLoadingAdvice}
            />

            <Route exact
              path={`/${ActionTypes.LOB}/viewindenttransporter`}
              component={ViewIndentTransporterDetails}
            />

            <Route exact
              path={`/${ActionTypes.LOB}/indentvehiclereporting`}
              component={IndentVehicleReporting}
            />

            <Route exact
              path={`/${ActionTypes.LOB}/indentvehicleloading`}
              component={IndentVehicleLoading}
            />
            <Route exact
              path={`/${ActionTypes.LOB}/indentvehiclegoods`}
              component={IndentVehicleGoods}
            />

            <Route exact
              path={`/${ActionTypes.LOB}/indentvehicledelivery`}
              component={IndentVehicleDelivery}
            />
            <Route exact
              path={`/${ActionTypes.LOB}/indentvehicletracking`}
              component={IndentVehicleTracking}
            />

            <Route exact
              path={`/${ActionTypes.LOB}/createvehicletracking`}
              component={CreateVehicleTracking}
            />

            <Route exact
              path={`/${ActionTypes.LOB}/createstockverification`}
              component={CreateStockVerification}
            />

            <Route exact
              path={`/${ActionTypes.LOB}/editvehicletracking`}
              component={EditVehicleTracking}
            />

            <Route exact
              path={`/${ActionTypes.LOB}/editvehiclereport`}
              component={IndentEditVehicleReport}
            />

            <Route exact
              path={`/${ActionTypes.LOB}/indent-vehicle-tracking`}
              component={IndentVehicleTracking}
            />

            <Route exact
              path={`/${ActionTypes.LOB}/view-indent-vehicle-tracking`}
              component={ViewIndentVehicleTracking}
            />

            <Route exact
              path={`/${ActionTypes.LOB}/view-indent-vehicle-reporting`}
              component={ViewIndentVehicleReporting}
            />

            <Route exact
              path={`/${ActionTypes.LOB}/masters/list-department-master`}
              component={ListDepartmentMaster}
            />
            <Route exact
              path={`/${ActionTypes.LOB}/masters/list-cha-master`}
              component={ListChaMaster}
            />

            <Route exact
              path={`/${ActionTypes.LOB}/masters/list-consignee-master`}
              component={ListConsigneeMaster}
            />

            <Route exact
              path={`/${ActionTypes.LOB}/masters/list-consigner-master`}
              component={ListConsignerMaster}
            />

            <Route exact
              path={`/${ActionTypes.LOB}/edit-equipment-fuel-consumption`}
              component={EditEquipmenrFuelConsumption}
            />

            <Route exact
              path={`/${ActionTypes.LOB}/edit-equipment-preventive-maintainance`}
              component={EditEquipmenrPreventiveMaintainance}
            />

            <Route exact
              path={`/${ActionTypes.LOB}/edit-equipment-maintainance`}
              component={EditEquipmentMaintainance}
            />

            <Route exact
              path={`/${ActionTypes.LOB}/edit-equipment-complianance`}
              component={EditEquipmentComplianance}
            />

            <Route exact
              path={`/${ActionTypes.LOB}/equipment-list`}
              component={EquipmentComplianceList}
            />

            <Route exact
              path={`/${ActionTypes.LOB}/edit-stock-verification`}
              component={EditStockVerification}
            />
            <Route exact
              path={`/${ActionTypes.LOB}/list-invoice`}
              component={InvoiceList}
            />

            <Route exact
              path={`/${ActionTypes.LOB}/list-sparestockmanagement`}
              component={SpareStockManagementList}
            />

            <Route exact
              path={`/${ActionTypes.LOB}/createinvoice`}
              component={CreateInvoice}
            />

            <Route exact
              path={`/${ActionTypes.LOB}/edit-invoice`}
              component={EditInvoice}
            />

            <Route exact
              path={`/${ActionTypes.LOB}/edit-safety-employee`}
              component={UpdateSafetyEmployee}
            />

            <Route exact
              path={`/${ActionTypes.LOB}/edit-spare-stock-management`}
              component={EditSpareStockManagement}
            />

            <Route exact
              path={`/${ActionTypes.LOB}/list-safety-employee`}
              component={SafetyEmployeeList}
            />

            <Route exact
              path={`/${ActionTypes.LOB}/createcustomdetails`}
              component={CreateCustomDetails}
            />

            <Route exact
              path={`/${ActionTypes.LOB}/viewcustomdetails`}
              component={ViewCustomDetails}
            />

            <Route exact
              path={`/${ActionTypes.LOB}/editcustomdetails`}
              component={UpdateCustomDetails}
            />

            {/* form a nd b */}
            <Route exact path={`/${ActionTypes.LOB}/forma`} component={FormA} />
            <Route exact path={`/${ActionTypes.LOB}/formb`} component={FormB} />

            <Route exact
              path={`/${ActionTypes.LOB}/masters/uploadexcelwithchail`}
              component={UploadExcel}
            />

            {/* Space Certificates */}
            <Route exact
              path={`/${ActionTypes.LOB}/masters/listspacecertificates`}
              component={SpaceCertificatesComponent}
            />

            <Route exact
              path={`/${ActionTypes.LOB}/databulkupload`}
              component={BulkUploadData}
            />

            <Route exact
              path={`/${ActionTypes.LOB}/masters/sappendingreasonmaster`}
              component={SapPendingReasonsList}
            />

            <Route exact
              path={`/${ActionTypes.LOB}/masters/receipttypemaster`}
              component={ReceiptTypeMaster}
            />

            <Route exact
              path={`/${ActionTypes.LOB}/stockregularization`}
              component={StockRegularization}
            />
            <Route exact
              path={`/${ActionTypes.LOB}/masters/list-uom-master`}
              component={ListUomMaster}
            />
            <Route exact
              path={`/${ActionTypes.LOB}/masters/uommaster`}
              component={UomMaster}
            />

            <Route exact
              path={`/${ActionTypes.LOB}/masters/edituommaster`}
              component={EditUomMaster}
            />
          </>
        }

        {/* **************** All Reports ******************* */}

        {(sessionStorage.getItem("user_type") === 'Customer' || sessionStorage.getItem("user_type") === 'WH User') &&
          <>
            <Route exact
              path={`/${ActionTypes.LOB}/stockreport`}
              component={StockReport}
            />
            <Route exact
              path={`/${ActionTypes.LOB}/agricoreport`}
              component={AgricoReport}
            />
            <Route exact path={`/${ActionTypes.LOB}/grnreport`} component={GRNReport} />

            <Route exact
              path={`/${ActionTypes.LOB}/packagelevelreport`}
              component={PackageLevelReport}
            /> 

            <Route exact
              path={`/${ActionTypes.LOB}/vivoreceiptreport`}
              component={VIVOReceiptReport}
            />
            <Route exact
              path={`/${ActionTypes.LOB}/vivoissuereport`}
              component={VIVOISSUEReport}
            />
             <Route exact
              path={`/${ActionTypes.LOB}/vivoreport`}
              component={VIVOReport}
            />
            <Route exact path={`/${ActionTypes.LOB}/gireport`} component={GIReport} />

            <Route exact
              path={`/${ActionTypes.LOB}/picklistreport`}
              component={MaterialPickListReport}
            />

            <Route exact
              path={`/${ActionTypes.LOB}/stockreportims`}
              component={StockReportIMS}
            />
            <Route exact
              path={`/${ActionTypes.LOB}/stockreportrm`}
              component={StockReportRM}
            />
            <Route exact
              path={`/${ActionTypes.LOB}/stockreportexwh`}
              component={StockReportEXWH}
            />

            <Route exact
              path={`/${ActionTypes.LOB}/diversionreport`}
              component={DiversionReport}
            />

            <Route exact
              path={`/${ActionTypes.LOB}/sapgrnpendingreport`}
              component={SapPendingReport}
            />
            <Route exact
              path={`/${ActionTypes.LOB}/masters/vehicletypemaster`}
              component={VehicleTypeMasterList}
            />
          </>
        }

        <Route exact render={() => <Redirect to={{
          pathname: sessionStorage.getItem("user_type") === 'Customer' ?
            `/${ActionTypes.LOB}/dashboard` : `/${ActionTypes.LOB}/dashboard`
        }} />} />

        {/* <Route path="*">
          <Redirect to={`/${ActionTypes.LOB}/dashboard`} />
        </Route> */}
      </Suspense>
    </Switch>
  );
}